import React, { createContext, useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useLazyQuery } from '@apollo/react-hooks';
import { SearchContext } from '../../../../components/SearchContext';
import appsAppListings from './AppListings.graphql';

export const AppListingContext = createContext({
  appListings: [],
});

export const AppListingProvider = ({ children }) => {
  const [appListings, setAppListings] = useState([]);
  const { search, filters } = useContext(SearchContext);

  const [getAppListings, { loading, error, data }] = useLazyQuery(appsAppListings);

  useEffect(() => {
    if (data?.fetchPublishedApplicationListings?.data) {
      setAppListings(data.fetchPublishedApplicationListings.data);
    }
  }, [data]);

  useEffect(() => {
    console.error(error);
  }, [error]);

  useEffect(() => {
    if (search || filters.length > 0) {
      getAppListings({ variables: { search, filters } });
    }
  }, [getAppListings, search, filters]);

  if (loading) return <p>Loading...</p>;

  return <AppListingContext.Provider value={{ appListings }}>{children}</AppListingContext.Provider>;
};

AppListingProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AppListingContext;
